import Vue from 'vue'
import VueI18n from 'vue-i18n'
import fr from './fr-CA.json'

Vue.use(VueI18n)

const dateTimeFormats = {
  'fr-CA': {
    short: {
      year: 'numeric',
      month: 'short',
      day: 'numeric',
    },
    long: {
      year: 'numeric',
      month: 'short',
      day: 'numeric',
      weekday: 'short',
      hour: 'numeric',
      minute: 'numeric',
    },
  },
}

export function createI18n() {
  return new VueI18n({
    locale: 'fr-CA',
    dateTimeFormats,
    messages: {
      'fr-CA': fr,
    },
  })
}



// WEBPACK FOOTER //
// ./src/i18n/index.js